// store/slices/userSlice.ts
import mixpanel from 'mixpanel-browser';
import { env } from '@/env';
import { LocalUser, UserState } from '../types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: UserState = {
  data: null,
  isRetrieved: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<LocalUser | null>) => {
      state.data = action.payload;
    },
    setIsRetrieved: (state, action: PayloadAction<boolean>) => {
      state.isRetrieved = action.payload;
    },
    logout: (state) => {
      if (env.VITE_MIXPANEL_TOKEN) {
        mixpanel.reset();
      }
      state.data = null;
      state.isRetrieved = false;
    },
  },
});

export const { setUser, setIsRetrieved, logout } = userSlice.actions;
export default userSlice.reducer;
